<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="
                  card-title
                  float-lefttitle-typography-color
                  title-typography-color
                ">
              <i class="fas fa-wallet"></i>
              {{ $t("public.views.Pages.Patient.Wallet.title") }}
            </h4>
          </template>
          <template v-slot:headerAction>
            <b-badge class="mr-2" variant="primary">{{ $t("public.views.Pages.Patient.Wallet.balance") }}
              {{ walletBalance.toFixed(2) }} €
            </b-badge>
            <b-button ref="btnShowNewVisit" class="mr-2" style="right" variant="success" @click="openModalCharge">{{
                $t("public.views.Pages.Patient.Wallet.btnCharge")
              }}
            </b-button>
          </template>
          <template v-slot:body>
            <div class="text-right">
              <b-button class="mb-3 mr-1" variant="secondary" @click="getWalletTransactionsExcel">
                Excel
              </b-button>
            </div>
            <div>
              <v-data-table :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'fas fa-arrow-left',
                lastIcon: 'fas fa-arrow-right',
                prevIcon: 'fas fa-minus',
                nextIcon: 'fas fa-plus',
                'items-per-page-options': [10, 25, 50],
              }" :headers="headers" :items="walletTransactions" :options.sync="pagination" :server-items-length="total"
                item-key="id">
                <template v-slot:item.date="{ item }">
                  <div v-if="item.date">
                    {{ item.date | adjustToTimezone("DD/MM/YYYY HH:mm") }}
                  </div>
                </template>
                <template v-slot:item.acto="{ item }">
                  <div v-if="item.type">
                    {{
                $t("public.views.Pages.Patient.Wallet.type." + item.type)
              }}
                  </div>
                </template>
                <template v-slot:item.payment="{ item }">
                  <div v-if="item.payment.paymentStatus">
                    {{
                $t(
                  "public.views.Pages.Patient.Wallet.status." +
                  item.payment.paymentStatus
                )
              }}
                  </div>
                </template>
                <template v-slot:item.user="{ item }">
                  <b-list-group-item v-if="item.professionalCharge" class="d-flex align-items-center border-0 p-0">
                    <span class="w-25">{{
                $t("public.views.Pages.Patient.Wallet.professional")
              }}:</span>
                    <b-avatar v-bind:src="item.professionalCharge.avatarUrl
                  ? item.professionalCharge.avatarUrl +
                  '/' +
                  getAuthentication()
                  : ''
                "></b-avatar>
                    <div class="media-support-info ml-3">
                      <p class="mb-0 font-size-16">
                        {{ item.professionalCharge.name }}
                      </p>
                      <p class="mb-0 font-size-12">
                        {{ item.professionalCharge.lastname }}
                      </p>
                    </div>
                  </b-list-group-item>
                  <b-list-group-item v-else class="d-flex align-items-center border-0 p-0">
                    <span class="w-25">{{
                $t("public.views.Pages.Patient.Wallet.patient1")
              }}:</span>
                    <b-avatar v-bind:src="item.patient.avatarUrl
                  ? item.patient.avatarUrl +
                  '/' +
                  getAuthentication()
                  : ''
                "></b-avatar>
                    <div class="media-support-info ml-3">
                      <p class="mb-0 font-size-16">{{ item.patient.name }}</p>
                      <p class="mb-0 font-size-12">
                        {{ item.patient.lastname }}
                      </p>
                    </div>
                  </b-list-group-item>
                </template>
                <template v-slot:item.cashFlow="{ item }">
                  <div v-if="item.cashFlow">
                    <b-badge v-if="item.type === 'CHARGE_PROFESSIONAL' ||
                item.type === 'CHARGE' ||
                item.type === 'EVENT_CANCEL'
                " variant="success">{{ parseFloat(item.cashFlow).toFixed(2) }} €
                    </b-badge>
                    <b-badge v-else variant="danger">{{ parseFloat(item.cashFlow).toFixed(2) }} €
                    </b-badge>
                  </div>
                </template>
                <template v-slot:item.event="{ item }">
                  <div v-if="item.event">
                    {{ item.event.startedAt | adjustToTimezone("DD/MM/YYYY HH:mm") }}
                  </div>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div class="div-table-data">
                    <button :id="'btnDetails' + item.id" class="item"
                      v-on:click="showDetails(item.event, item.comments)">
                      <i class="ri-file-paper-line"></i>
                    </button>
                    <b-popover :target="'btnDetails' + item.id" placement="botton" triggers="hover focus">
                      <template #title>{{
                $t("public.views.Pages.Patient.Wallet.btnDetails")
              }}
                      </template>
                    </b-popover>
                  </div>
                </template>
              </v-data-table>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-details" centered hide-footer>
      <template #modal-title>{{
                  $t("public.views.Pages.Patient.Wallet.modalDatails.title")
                }}
      </template>
      <template #modal-cancel>{{
                  $t("public.views.Pages.Patient.Wallet.modalDatails.btnCancel")
                }}
      </template>
      <b-form-group label-for="comments">
        <template slot="label">{{ $t("public.views.Pages.Patient.Wallet.modalDatails.comments") }}:
        </template>
        <b-form-textarea v-model="details.comments" :disabled="true" max-rows="6" rows="3"></b-form-textarea>
      </b-form-group>
      <div v-if="detailsEvent">
        <b-form-group label-for="patients">
          <template slot="label">{{
                $t("public.views.Pages.Patient.Wallet.modalDatails.patients")
              }}:
          </template>
          <b-input v-model="details.patients" :disabled="true" type="text"></b-input>
        </b-form-group>
        <b-form-group label-for="professionals">
          <template slot="label">{{
                $t(
                  "public.views.Pages.Patient.Wallet.modalDatails.professionals"
                )
              }}:
          </template>
          <b-input v-model="details.professionals" :disabled="true" type="text"></b-input>
        </b-form-group>
        <b-form-group label-for="visitType">
          <template slot="label">{{
                $t("public.views.Pages.Patient.Wallet.modalDatails.visitType")
              }}:
          </template>
          <b-input v-model="details.visitType" :disabled="true" type="text"></b-input>
        </b-form-group>
        <b-form-group label-for="date">
          <template slot="label">{{ $t("public.views.Pages.Patient.Wallet.modalDatails.date") }}:
          </template>
          <b-input v-model="details.date" :disabled="true" type="text"></b-input>
        </b-form-group>
      </div>
    </b-modal>
    <b-modal id="modal-charge" centered hide-footer size="sm">
      <template #modal-title>{{
                $t("public.views.Pages.Patient.Wallet.modalPay.title")
              }}
      </template>
      <template #modal-cancel>{{
                  $t("public.views.Pages.Patient.Wallet.modalPay.btnCancel")
                }}
      </template>
      <div class="payment-btn-center">
        <b-col cols="12">
          <b-row>
            <div>
              {{ $t("public.views.Pages.Patient.Wallet.inputPrice") }}: *
            </div>
            <div class="input-group mb-3">
              <input v-model="charge" class="form-control" type="number" />
              <div class="input-group-append">
                <span class="input-group-text">€</span>
              </div>
            </div>
          </b-row>
          <b-row>
            <i v-if="user &&
                user.userOrganizations &&
                user.userOrganizations[0] &&
                user.userOrganizations[0].paymentModePasarelaPaypal
                " id="btnPaypal" class="fab fa-paypal fa-4x fa-fw cursor-point" @click="showPaypalPayment"></i>
            <b-popover v-if="user &&
                user.userOrganizations &&
                user.userOrganizations[0] &&
                user.userOrganizations[0].paymentModePasarelaPaypal
                " :target="'btnPaypal'" placement="botton" triggers="hover focus">
              <template #title>{{
                $t("public.views.Pages.Patient.Dashboard.modalPay.btnPaypal")
              }}
              </template>
            </b-popover>
            <i v-if="user &&
                user.userOrganizations &&
                user.userOrganizations[0] &&
                user.userOrganizations[0].paymentModePasarelaStripe
                " id="btnStripe" class="fab fa-stripe fa-4x fa-fw cursor-point" @click="showStripePayment"></i>
            <b-popover v-if="user &&
                user.userOrganizations &&
                user.userOrganizations[0] &&
                user.userOrganizations[0].paymentModePasarelaStripe
                " :target="'btnStripe'" placement="botton" triggers="hover focus">
              <template #title>{{
                $t("public.views.Pages.Patient.Dashboard.modalPay.btnStripe")
                }}
              </template>
            </b-popover>
          </b-row>
        </b-col>
      </div>
    </b-modal>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import { xray } from "../../../config/pluginInit";
import { StripeCheckout } from "@vue-stripe/vue-stripe";
import validator from "vue-m-validator";

import { mapActions, mapGetters } from "vuex";

import { loadStripe } from "@stripe/stripe-js";

import walletService from "../../../services/wallet";
import patientService from "../../../services/patient";
import utilsService from "../../../services/utils";
import userService from "../../../services/user";

export default {
  name: "WalletPatient",
  mounted() {
    xray.index();
    this.verifyPay();
    this.getUser();
    this.getAllWalletTransactions(localStorage.getItem("userId"));

    utilsService.auditActivity({ action: "VIEW", module: "PATIENT_WALLET", info: "" });
  },
  methods: {
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    openModalCharge() {
      this.$bvModal.show("modal-charge");
    },
    getWalletTransactionsExcel() {
      var objectUrl =
        process.env.VUE_APP_BASE_URL_CORE +
        "auth/wallet/" +
        this.user.walletId +
        "/transactions/excel?token=" +
        localStorage.getItem("authorization");
      window.open(objectUrl);
    },
    getWalletBalance() {
      let self = this;

      this.$awn.asyncBlock(
        walletService.get(this.user.walletId),
        (response) => {
          if (response) {
            self.walletBalance = response.data.total;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "walletService.get",
            module: "view-pages-patient-wallet",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              walletId: this.user.walletId
            })
          });
        },
        " "
      );
    },
    showDetails(event, comments) {
      if (event) {
        this.detailsEvent = true;
        let patients = "";
        event.patients.forEach(function (item) {
          patients = patients + item.name + " " + item.lastname;
        });

        let professionals = "";
        event.professionals.forEach(function (item) {
          professionals = professionals + item.name + " " + item.lastname;
        });

        this.details = {
          comments: comments,
          patients: patients,
          professionals: professionals,
          visitType: event.visitType.name,
          date: new Date(event.startedAt).toLocaleString(),
        };
      } else {
        this.detailsEvent = false;
        this.details = {
          comments: comments,
        };
      }

      this.$bvModal.show("modal-details");
    },
    // Modal validator
    checkCharge(_charge) {
      const CHARGE = _charge.trim();
      const RULE_1 = {
        expression: !CHARGE || CHARGE === "",
        name: "name",
        msg: this.$i18n.t(
          "public.views.Pages.Patient.Wallet.modalCharge.errors.charge"
        ),
      };
      const RULE_2 = {
        expression: CHARGE === "0",
        name: "name",
        msg: this.$i18n.t(
          "public.views.Pages.Patient.Wallet.modalCharge.errors.chargeEqualsZero"
        ),
      };
      validator.addRule(RULE_1).addRule(RULE_2);
      this.notFirst();
    },
    notFirst() {
      this.isFirstRun = false;
    },
    checkFormCharge() {
      this.checkCharge(this.charge);
    },
    showCharge(pay) {
      this.checkFormCharge();
      if (this.validator.errors.length === 0) {
        if (pay === "STRIPE") {
          this.showStripePayment();
        }

        if (pay === "PAYPAL") {
          this.showPaypalPayment();
        }
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.views.Pages.Patient.Wallet.modalCharge.error.notify.title"
          ),
          text: this.$i18n.t(
            "public.views.Pages.Patient.Wallet.modalCharge.error.notify.text"
          ),
          type: "error",
        });
      }
    },
    // List
    async getUser() {
      let self = this;

      userService
        .get(localStorage.getItem("userId"))
        .then((response) => {
          if (response) {
            self.user = response.data;

            // Wallet
            if (self.user.walletId !== null) {
              self.walletId = self.user.walletId;
            }

            self.getWalletBalance();
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "userService.get",
            module: "view-pages-patient-wallet",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              userId: localStorage.getItem("userId")
            })
          });
        });
    },
    getAllWalletTransactions(patientId) {
      let self = this;

      this.$awn.asyncBlock(
        patientService.getAllTransactionsWallet(
          this.pagination.page - 1,
          this.pagination.itemsPerPage,
          patientId
        ),
        (response) => {
          if (response) {
            self.walletTransactions = response.data.content;
            self.total = response.data.pageable.total;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.getAllTransactionsWalle",
            module: "view-pages-patient-wallet",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              page: this.pagination.page - 1,
              itemsPerPage: this.pagination.itemsPerPage,
              patientId: patientId
            })
          });
        },
        " "
      );
    },
    // Charge
    openModalCharge() {
      this.$bvModal.show("modal-charge");
    },
    showStripePayment() {
      let self = this;

      let data = {
        charge: this.charge,
        organizationId: localStorage.getItem("organizationId"),
      };

      this.$awn.asyncBlock(
        walletService.payStripe(this.walletId, data),
        (response) => {
          if (response) {
            self.stripe = response.data;

            utilsService.auditActivity({ action: "CREATE", module: "PATIENT_WALLET_SUCCESS_STRIPE", info: "" });

            let stripeInit = loadStripe(self.stripe.publicKey);
            // wait for the promise to resolve first
            stripeInit.then((stripe) => {
              stripe
                .redirectToCheckout({
                  sessionId: self.stripe.idSession,
                })
                .then(function (result) {
                })
                .catch(function (error) {
                  console.error(error);
                });
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "walletService.payStripe",
            module: "view-pages-patient-wallet",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              walletId: this.walletId, data: data
            })
          });
        },
        " "
      );
    },
    showPaypalPayment() {
      let self = this;

      let data = {
        charge: this.charge,
        organizationId: localStorage.getItem("organizationId"),
      };

      this.$awn.asyncBlock(
        walletService.payPaypal(this.walletId, data),
        (response) => {
          if (response) {

            utilsService.auditActivity({ action: "CREATE", module: "PATIENT_WALLET_SUCCESS_PAYPAL", info: "" });

            self.paypal = response.data;
            window.location.href = self.paypal.url;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "walletService.payPaypal",
            module: "view-pages-patient-wallet",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              walletId: this.walletId, data: data
            })
          });
        },
        " "
      );
    },
    paySuccess(paymentPlataformId, walletId, mode, token, data) {
      let self = this;

      this.$awn.asyncBlock(
        walletService.paySuccess(
          paymentPlataformId,
          walletId,
          mode,
          token,
          data
        ),
        (response) => {
          utilsService.auditActivity({ action: "CREATE", module: "PATIENT_WALLET_SUCCESS", info: "" });
          self.getAllWalletTransactions(localStorage.getItem("userId"));
          self.getWalletBalance();
          self.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.views.Pages.Patient.Wallet.notification.title"
            ),
            text: this.$i18n.t(
              "public.views.Pages.Patient.Wallet.notification.descPay"
            ),
            type: "success",
          });
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "walletService.paySuccess",
            module: "view-pages-patient-wallet",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              paymentPlataformId: paymentPlataformId,
              walletId: walletId,
              mode: mode,
              token: token,
              data: data
            })
          });
        },
        " "
      );
    },
    payCancel(paymentPlataformId, walletId, mode, token, data) {
      let self = this;

      this.$awn.asyncBlock(
        walletService.payCancel(
          paymentPlataformId,
          walletId,
          mode,
          token,
          data
        ),
        (response) => {
          utilsService.auditActivity({ action: "CREATE", module: "PATIENT_WALLET_CANCEL", info: "" });
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.views.Pages.Patient.Wallet.notification.error"
            ),
            text: this.$i18n.t(
              "public.views.Pages.Patient.Wallet.notification.descUnpay"
            ),
            type: "error",
          });
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "walletService.payCancel",
            module: "view-pages-patient-wallet",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              paymentPlataformId: paymentPlataformId,
              walletId: walletId,
              mode: mode,
              token: token,
              data: data
            })
          });
        },
        " "
      );
    },
    //Pay
    async verifyPay() {
      if (
        this.$route.query.action !== undefined &&
        this.$route.query.mode !== undefined &&
        this.$route.query.tokenback !== undefined &&
        this.$route.query.token !== undefined &&
        this.$route.query.paymentId !== undefined &&
        this.$route.query.paymentPlataformId !== undefined &&
        this.$route.query.walletId !== undefined &&
        this.$route.query.PayerID !== undefined
      ) {
        if (this.$route.query.action === "success") {
          let data = {
            tokenPaypal: this.$route.query.token,
            paymentIdPaypal: this.$route.query.paymentId,
            payerIDPaypal: this.$route.query.PayerID,
          };

          this.paySuccess(
            this.$route.query.paymentPlataformId,
            this.$route.query.walletId,
            this.$route.query.mode,
            this.$route.query.tokenback,
            data
          );
        }
      }
      if (
        this.$route.query.action !== undefined &&
        this.$route.query.mode !== undefined &&
        this.$route.query.tokenback !== undefined &&
        this.$route.query.token !== undefined
      ) {
        if (this.$route.query.action === "cancel") {
          let data = {
            tokenPaypal: this.$route.query.token,
            paymentIdPaypal: this.$route.query.paymentId,
            payerIDPaypal: this.$route.query.PayerID,
          };

          this.payCancel(
            this.$route.query.paymentPlataformId,
            this.$route.query.walletId,
            this.$route.query.mode,
            this.$route.query.tokenback,
            data
          );
        }
      }
      if (
        this.$route.query.action !== undefined &&
        this.$route.query.mode !== undefined &&
        this.$route.query.tokenback !== undefined
      ) {
        if (this.$route.query.action === "success") {
          let data = {
            tokenPaypal: this.$route.query.token,
            paymentIdPaypal: this.$route.query.paymentId,
            payerIDPaypal: this.$route.query.PayerID,
          };

          this.paySuccess(
            this.$route.query.paymentPlataformId,
            this.$route.query.walletId,
            this.$route.query.mode,
            this.$route.query.tokenback,
            data
          );
        }
        if (this.$route.query.action === "cancel") {
          let data = {
            tokenPaypal: "",
            paymentIdPaypal: "",
            payerIDPaypal: "",
          };

          this.payCancel(
            this.$route.query.paymentPlataformId,
            this.$route.query.walletId,
            this.$route.query.mode,
            this.$route.query.tokenback,
            data
          );
        }
      }
    },
  },
  computed: {
    //Validate form
    isDisabled() {
      return this.isFirstRun === true || this.validator.errors.length > 0;
    },
    isFormChargeErrors() {
      let errors = this.validator.getErrors("charge");
      return errors && errors.length > 0;
    },
    ...mapGetters({
      selectedUser: "Setting/userState",
    }),
  },
  data() {
    return {
      total: 0,
      pagination: { page: 1, itemsPerPage: 10 },
      detailsEvent: true,
      //Global
      details: {},
      user: {},
      validator: validator,
      isFirstRun: true,
      isValidate: false,
      //Modal charge
      walletBalance: 0,
      walletId: "",
      charge: "1",
      // Payments
      stripe: {
        publicKey: "",
        idSession: "",
      },
      paypal: {
        url: "",
      },
      //Table

      headers: [
        {
          text: this.$i18n.t("public.views.Pages.Patient.Wallet.headers.date"),
          align: "start",
          value: "date",
        },
        {
          text: this.$i18n.t("public.views.Pages.Patient.Wallet.headers.acto"),
          value: "acto",
        },
        {
          text: this.$i18n.t("public.views.Pages.Patient.Wallet.headers.user"),
          value: "user",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Patient.Wallet.headers.cashFlow"
          ),
          value: "cashFlow",
        },
        {
          text: this.$i18n.t("public.views.Pages.Patient.Wallet.headers.event"),
          value: "event",
        },
        {
          text: "",
          value: "actions",
        },
      ],
      walletTransactions: [],
    };
  },
  components: {
    StripeCheckout,
  },
};
</script>
